import { render, staticRenderFns } from "./DailyScoreFilter.vue?vue&type=template&id=37971e43&"
import script from "./DailyScoreFilter.vue?vue&type=script&lang=js&"
export * from "./DailyScoreFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports